<template>
  <div id="app">
    <el-container class="app-container">
      <el-header class="p-0">
        <page-header active-index="search" />
      </el-header>

      <el-main>
        <div>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
      </el-main>

      <el-footer height="80px" class="p-0">
        <page-footer />
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  }
}
</script>

<style lang="scss" scoped>
.app-container {
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue